import Vue from 'vue';
import MyIcon from './my-icon/index.vue';

const componentList = [
    MyIcon
]

componentList.forEach( c => {
    Vue.component(c.name,c);
})